import React from 'react';
import { Button } from '@signicat/designi/components/buttons';
import { Modal } from '@signicat/designi/components/overlays';
import { Grid } from '@signicat/designi/components/layout';
import { Paragraph } from '@signicat/designi/components/text';
import { t } from "../helpers/i18n";
import styled from 'styled-components';
var StyledParagraph = styled(Paragraph).withConfig({
  displayName: "SignerDetails__StyledParagraph",
  componentId: "sc-wfm60d-0"
})(["font-size:14px;text-transform:uppercase;font-weight:600;letter-spacing:0.05em;margin-bottom:8px !important;width:auto;display:inline-block;"]);
var SignerDetails = function SignerDetails(props) {
  var isSending = props.isSending,
    signer = props.signer,
    close = props.close;
  var handleCancelClick = function handleCancelClick() {
    close();
  };
  var signerInfo = /*#__PURE__*/React.createElement(Grid, {
    container: true,
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(StyledParagraph, null, t('signer_details_contact_info_heading'))), signer.firstName || signer.lastName ? /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, "".concat(signer.firstName || '', " ").concat(signer.lastName || '')) : null, signer.companyName ? /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, signer.companyName) : null, signer.companyRole ? /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, signer.companyRole) : null, signer.email ? /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, signer.email) : null, signer.mobileNumber ? /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, signer.mobileNumber) : null, /*#__PURE__*/React.createElement("br", null), " ", /*#__PURE__*/React.createElement("br", null));
  return /*#__PURE__*/React.createElement(Modal, {
    isLoading: isSending
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    item: true,
    spacing: 2
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    item: true,
    xs: 12
  }, signerInfo, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    direction: "row",
    item: true,
    xs: 12,
    justifyContent: "flex-start",
    style: {
      marginTop: '48px'
    }
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: handleCancelClick,
    disabled: isSending
  }, t('close'))))));
};
export default SignerDetails;